import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'phoneNumber' })
export class PhoneNumberPipe implements PipeTransform {
  transform(phoneString: string, format: string = '(xxx) xxx-xxxx'): any {
    let re = /(\d{10})(\s){0,1}(ext\#){0,1}(\d*){0,20}/;
    let m = re.exec(phoneString);
    if (m !== null) {
      if (m.index === re.lastIndex) {
        re.lastIndex++;
      }
      let phoneNumber = '';
      if (m[ 1 ]) {
        phoneNumber = this.parse(m[ 1 ], format);
      }
      if (m[ 4 ]) {
        phoneNumber += ' ext. ' + m[ 4 ];
      }
      return phoneNumber;
    } else {
      return phoneString;
    }
  }

  // Copied and translated to TS from https://raw.githubusercontent.com/chenglou/phone-parser/master/index.js
  private parse(inputParam: string, formatParam: string): string {
    // Trim away everything that's not a digit.
    let inputStr = inputParam.replace(/\D/g, '');
    // Split to array for easier popping.
    let inputArr = inputStr.split('');
    let formatArr = formatParam.split('');
    let output = '';
    while (formatArr.length) {
      let currentFormatSymbol = formatArr.pop();
      if (currentFormatSymbol === 'x') {
        let digitToInsert = inputArr.pop();
        if (digitToInsert === undefined) { break; }
        output = digitToInsert + output;
      } else {
        output = currentFormatSymbol + output;
      }
    }

    if (inputArr.length !== 0 || formatArr.length !== 0) {
      throw new Error('Phone format cannot be parsed.');
    }
    return output;
  }


}
